export default "__VITE_ASSET__t_e0nzU8__"